import NavigationMenu from "./NavigationMenu";

interface NavigationMenuDesktopProps {
  isEditing: boolean;
}

const NavigationMenuDesktop = ({ isEditing }: NavigationMenuDesktopProps) => <NavigationMenu isEditing={isEditing} />;

export default NavigationMenuDesktop;
